import { useState } from "react";
import { Link } from "react-router-dom";
import logo from '../../assets/newlogo.png'
import DonateButton from './DonateButton';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center gap-4 max-w-[35%]">
            <Link to="/" className="cursor-pointer block">
              <img
                src={logo}
                className="w-full h-16 object-contain"
                alt="Logo"
              />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            <Link
              to="/solution"
              className="px-4 py-2.5 text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            >
              Our Solution
            </Link>
            {[
              { href: "#publications", label: "Profile" },
              { href: "#cours", label: "Learning" },
              { href: "#qa", label: "Community" },
              { href: "#ia", label: "AI Copilot" },
              
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="px-4 py-2.5 text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              >
                {item.label}
              </a>
            ))}
            <Link
                to='/marketplace'
                className="px-4 py-2.5 text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              >
                Marketplace
              </Link>
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <DonateButton />
            <Link
              to="/"
              className="px-5 py-2.5 text-sm font-semibold text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg transition-colors"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="px-6 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-emerald-500 rounded-lg hover:shadow-lg transition-all duration-300"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`lg:hidden ${isMenuOpen ? 'block' : 'hidden'} pb-4`}>
          <div className="flex flex-col space-y-1">
            <Link
              to="/about"
              onClick={() => setIsMenuOpen(false)}
              className="px-4 py-3 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            >
              Our Solution
            </Link>
            {[
              { href: "#publications", label: "Profile" },
              { href: "#cours", label: "Learning" },
              { href: "#qa", label: "Community" },
              { href: "#ia", label: "AI Copilot" }
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setIsMenuOpen(false)}
                className="px-4 py-3 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              >
                {item.label}
              </a>
            ))}
            <Link
                to='/marketplace'
                className="px-4 py-2.5 text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              >
                Marketplace
              </Link>
            <div className="pt-4 border-t border-gray-200 mt-2">
              <div className="mb-2 flex justify-center">
                <DonateButton />
              </div>
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className="block text-center px-4 py-3 text-base font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg transition-colors mb-2"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                onClick={() => setIsMenuOpen(false)}
                className="block text-center px-4 py-3 text-base font-medium text-white bg-gradient-to-r from-blue-500 to-emerald-500 rounded-lg hover:shadow-lg transition-all duration-300"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}